export enum PushNotificationsState {
  /**
   * The user can't receive push notifications because the permissions were not granted.
   */
  UnsubscribedPermissionsNotGranted = 'unsubscribed-permissions-not-granted',

  /**
   * The user can't receive push notifications because the browser they are using is not supported.
   */
  UnsubscribedNotSupported = 'unsubscribed-not-supported',

  /**
   * The user can't receive push notifications because an error occurred.
   */
  UnsubscribedError = 'unsubscribed-error',

  /**
   * The user can receive push notifications.
   */
  Subscribed = 'subscribed',

  /**
   * The user was not subscribed yet or was unsubscribed (during logout, for example).
   */
  Unknown = 'unknown',
}
